import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { SynchronizationService } from '../synchronization.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-synchronization-activate',
    templateUrl: './synchronization-activate.component.html',
    styleUrl: './synchronization-activate.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})
export class SynchronizationActivateComponent {

  @Input() activatationKey: string = '';

  activateSync: boolean = false;
  externalkey: string = '';

  constructor(
    private synchronizationService: SynchronizationService,
    public activeModal: NgbActiveModal,
  ) { }

  canActivate() {
    return this.externalkey.length >= 10;
  }

  activateSyncronization() {
    this.activateSync = true;
    this.synchronizationService.activateSynchronization(this.activatationKey, btoa(this.externalkey)).then(() => {
      this.activeModal.close(true);
    }).catch(() => {
      // HTTP-fejl vises globalt af GlobalErrorInterceptor/ErrorService
    }).finally(() => {
      this.activateSync = false;
    });
  }
}
